// extracted by css-extract-rspack-plugin
export default {"calendarIcon":"ListHeader-module__calendarIcon__WikEB","breadcrumbItem":"ListHeader-module__breadcrumbItem__j7KrS"};